import {
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_BEGIN,
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_SUCCESS,
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_FAILURE,
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function saveExternaldatabaseForAirtable(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_BEGIN,
    });
    const { projectId, projectVersion } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${projectVersion}/airtable/save-externaldb`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveExternaldatabaseForAirtableError() {
  return {
    type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_BEGIN:
      return {
        ...state,
        saveExternaldatabaseForAirtablePending: true,
        saveExternaldatabaseForAirtableError: null,
      };

    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_SUCCESS:
      return {
        ...state,
        saveExternaldatabaseForAirtablePending: false,
        saveExternaldatabaseForAirtableError: null,
        externalDbUuid: action.data.uuid,
      };

    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_FAILURE:
      return {
        ...state,
        saveExternaldatabaseForAirtablePending: false,
        saveExternaldatabaseForAirtableError: action.data.error,
      };

    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_DISMISS_ERROR:
      return {
        ...state,
        saveExternaldatabaseForAirtableError: null,
      };

    default:
      return state;
  }
}
